import React from 'react';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { FlexBox } from '../FlexBox';

function LinearProgressWithLabel({
  value,
  total = 100,
  size,
  showPercentageInside,
  hideLabel = false,
  color = '#3c9d3d',
}) {
  const percentage = value ? (value < total ? (value / total) * 100 : 100) : 0;
  const barHeight =
    size === 'small'
      ? '16px'
      : size === 'verySmall'
        ? '10px'
        : size === 'medium'
          ? '20px'
          : '24px';

  return (
    <FlexBox alignItems="center" gap=".2rem" width="100%">
      <Box sx={{ position: 'relative', width: '100%' }}>
        <LinearProgress
          variant="determinate"
          value={percentage}
          sx={{
            height: barHeight,
            borderRadius: 5,
            [`& .${linearProgressClasses.bar}`]: {
              borderRadius: 5,
              backgroundColor: color,
            },
          }}
        />
        {showPercentageInside && (
          <Typography
            variant="caption"
            sx={{
              color: percentage > 50 ? 'common.white' : 'text.primary', //white only on the filled bar
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              lineHeight: 1,
              fontWeight: 600,
              userSelect: 'none',
              pointerEvents: 'none',
            }}
          >
            {`${Math.floor(percentage)}%`}
          </Typography>
        )}
      </Box>

      {Boolean(total) && !hideLabel && (
        <Typography
          variant="body1"
          sx={{
            minWidth: 62,
            flexGrow: 1,
            flexShrink: 0,
            userSelect: 'none',
            fontWeight: 'bold',
          }}
          noWrap
        >
          {`${value} / ${total}`}
        </Typography>
      )}
    </FlexBox>
  );
}

function ProgressBar({
  value,
  total = 100,
  size = 'small',
  showPercentageInside = false,
  hideLabel = false,
  color = undefined,
}) {
  return (
    <LinearProgressWithLabel
      value={value}
      total={total}
      size={size}
      showPercentageInside={showPercentageInside}
      hideLabel={hideLabel}
      color={color}
    />
  );
}

export default ProgressBar;
